module.exports = __webpack_public_path__ + "static/media/dashboard-logo-cropped.2c379e10.svg";